/** The numbered pip on a step's icon. */
function StepPip({ step }: { step: number }) {
  return (
    <span className="flex items-center justify-center absolute -top-0.5 -left-0.5 size-[18px] text-[11px] font-semibold leading-[14px] text-white bg-primary border-2 border-white rounded-full">
      {step}
    </span>
  );
}

/** 32px step icon with the numbered orange pip overlaid at top-left. */
export default function StepIcon({ src, step }: { src: string; step: number }) {
  return (
    <div className="relative shrink-0 w-8 h-8">
      <img src={src} alt="" aria-hidden="true" className="block w-8 h-8" />
      <StepPip step={step} />
    </div>
  );
}
